<template>
  <div class="col-md-12">
    <div class="form-group">
      <label for="address_company">Organization Name*</label>
      <input
        id="address_company"
        :value="addressObj.company"
        type="text"
        class="form-control"
        maxlength="255"
        disabled
      />
    </div>
    <div class="form-group">
      <label for="address_address">Address*</label>
      <input
        id="address_address"
        v-model="addressObj.address"
        type="text"
        class="form-control"
        maxlength="255"
      />
    </div>
    <div class="form-group">
      <label for="address_address2">Suite, Apt, etc.</label>
      <input
        id="address_address2"
        v-model="addressObj.address2"
        type="text"
        class="form-control"
        maxlength="255"
      />
    </div>
    <div class="form-group">
      <label for="address_city">City*</label>
      <input
        id="address_city"
        v-model="addressObj.city"
        type="text"
        class="form-control"
        maxlength="255"
      />
    </div>
    <div class="form-group">
      <label for="address_state">State / Province*</label>
      <select
        id="address_state"
        v-model="addressObj.state"
        class="form-control"
      >
        <option :value="null" disabled selected>
          -- Select State or Province --
        </option>
        <option
          v-for="(region, r) in locale.regions"
          :key="r"
          :value="region.region_code"
        >
          {{ region.region_name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label for="address_zip">Zip / Postal Code*</label>
      <input
        id="address_zip"
        v-model="addressObj.zip"
        type="text"
        class="form-control"
        maxlength="255"
      />
    </div>
    <div class="form-group">
      <label for="address_country">Country*</label>
      <select
        id="address_country"
        v-model="addressObj.country"
        class="form-control"
        disabled
      >
        <option :value="locale.locale | countryShorthand">
          {{ locale.country }}
        </option>
      </select>
    </div>
    <br />
    <div class="form-group">
      <button v-if="processing" class="btn btn-primary" disabled>
        Validating...
      </button>
      <button
        v-else
        class="btn btn-primary"
        :disabled="disabled"
        @click.prevent="validateAddress"
      >
        Validate address
      </button>
    </div>
    <!-- this is in the DOM, but we're pulling it out into the SWAL. This way we get the value of Vue while using the Swal.html stuff -->
    <div class="hidden">
      <div ref="validatedAddresses">
        <ul style="list-style: none; padding-inline-start: 0; margin-top: 2rem">
          <li
            v-for="(validAddress, index) in validatedAddresses"
            :key="index"
            style="padding-bottom: 1rem"
          >
            <button
              class="btn"
              :class="{
                'btn-primary': index === 0,
                'btn-secondary': index !== 0,
              }"
              @click.prevent="pickAddress(validAddress)"
            >
              {{ validAddress.address }} {{ validAddress.address2 }}
              <br />
              {{ validAddress.city }}, {{ validAddress.state }}
              {{ validAddress.county }}
              {{ validAddress.zip }}
              {{ validAddress.country }}
            </button>
          </li>
          <li v-if="validatedAddresses && validatedAddresses.length === 0">
            No matching address could be found
          </li>
        </ul>
        <a href="#" @click.prevent="selfCertifyAddress()">
          Keep my original address. I certify it is correct.
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import countryShorthand from "../../../filters/countryShorthand";

export default {
  filters: {
    countryShorthand,
  },

  props: {
    validationUrl: {
      type: String,
      required: true,
    },
    addressObj: {
      type: Object,
      required: true,
    },
    locale: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      validatedAddresses: [],
      processing: false,
      errorMessage: null,
    };
  },

  computed: {
    addressToValidate() {
      return {
        address: this.addressObj.address,
        address2: this.addressObj.address2,
        city: this.addressObj.city,
        state: this.addressObj.state,
        county: this.addressObj.county,
        zip: this.addressObj.zip,
        country: this.addressObj.country,
      };
    },
  },

  methods: {
    updateAddressWithValidatedAddress(validAddress) {
      return new Promise((resolve) => {
        Object.keys(this.addressToValidate).forEach((key) => {
          this.addressObj[key] = validAddress[key];
        });
        resolve();
      });
    },

    validateAddress() {
      this.processing = true;

      this.$http
        .post(this.validationUrl, this.addressToValidate)
        .then((res) => {
          if (res.data.includes("There was an error")) {
            this.errorMessage =
              "We are temporarily unable to validate your address. You may proceed without validation.";
            this.validatedAddress = [];
          } else {
            this.validatedAddresses = res.data;
          }

          this.$swal.fire({
            title: "Select a validated address",
            html: this.$refs.validatedAddresses,
            showCancelButton: true,
            showConfirmButton: false,
            width: "45rem",
          });
        })
        .catch((e) => {
          if (e.response.status !== 422) {
            this.errorMessage =
              "We are temporarily unable to validate your address. You may proceed without validation.";
            this.validatedAddress = [];
          } else {
            const errors = Object.values(e.response.data.errors)
              .flat()
              .join(" ");
            this.errorMessage = `Unable to validate address: ${errors}`;
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
    async pickAddress(validAddress) {
      this.errorMessage = null;

      await this.updateAddressWithValidatedAddress(validAddress);

      this.addressObj.validated_address = JSON.stringify(
        this.addressToValidate
      );
      this.addressObj.validation_type = "smarty-streets";

      this.$swal.close();
    },
    selfCertifyAddress() {
      this.errorMessage = null;

      this.addressObj.validated_address = null;
      this.addressObj.validation_type = "self-certified";

      this.$swal.close();
    },
  },
};
</script>
